import mervillePic from '../assets/team/MervilleCropped.png'; // Add your image path
import benjaminPic from '../assets/team/BenjaminCropped.png'; // Add your image path
import { useEffect } from 'react';
import clarity from '../utils/clarity';

export default function AboutUs() {

  useEffect(() => {
    clarity.pageView('/about-us');
  }, []);

  const handleContactClick = () => {
    clarity.event('about_us_contact_click');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-primary text-white py-20 pt-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            About Emplo
          </h1>
          <p className="text-xl max-w-3xl mx-auto">
            Transforming business education through innovative simulation technology
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-8 text-gray-900">
              Our Mission
            </h2>
            <p className="text-lg text-gray-600 mb-12">
              To empower the next generation of business leaders through immersive, practical learning experiences that bridge the gap between theory and real-world application.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-12 text-center text-gray-900">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Innovation */}
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">💡</span>
              </div>
              <h3 className="text-xl font-semibold mb-4 text-gray-900">
                Innovation
              </h3>
              <p className="text-gray-600">
                We constantly push the boundaries of educational technology to create more engaging and effective learning experiences.
              </p>
            </div>

            {/* Education */}
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📚</span>
              </div>
              <h3 className="text-xl font-semibold mb-4 text-gray-900">
                Education
              </h3>
              <p className="text-gray-600">
                We believe in making high-quality business education accessible and engaging for everyone.
              </p>
            </div>

            {/* Impact */}
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🌟</span>
              </div>
              <h3 className="text-xl font-semibold mb-4 text-gray-900">
                Impact
              </h3>
              <p className="text-gray-600">
                We strive to create lasting positive change in how people learn and develop business skills.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section - updated background */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-6 text-center text-gray-900">
            Our Team
          </h2>
          <p className="text-lg text-gray-600 text-center max-w-3xl mx-auto mb-16">
            We are Former Hubro-vians with 10+ years experience in simulation based and experiential learning.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Merville */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-xl transition-shadow duration-300">
              <div className="h-[500px] relative overflow-hidden">
                <img 
                  src={mervillePic}
                  alt="Merville Mouho"
                  className="absolute w-full h-full object-cover object-[center_35%] transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-8 bg-white relative transition-transform duration-300 group-hover:-translate-y-2 flex flex-col h-[400px]">
                <div className="flex-grow">
                  <h3 className="text-2xl font-bold mb-2 text-gray-900">Merville Mouho</h3>
                  <p className="text-primary font-medium mb-6 transition-colors duration-300 group-hover:text-primary-dark">
                    Founder and CEO
                  </p>
                  
                  <p className="text-gray-600">
                    As the former Head of sales at Hubro Education, I have had the privilege of developing simulation based learning journeys and courses for Schools, Universities and fortune 100 companies, impacting 10,000s of learners across 6 continents. I have experienced the powerful impact that simulation can have, on students learning outcomes for learners at all levels. I am super excited to continue this work with EmploSkills.
                  </p>
                </div>
                
                <div className="flex flex-col space-y-2 mt-6">
                  <a 
                    href="mailto:merville@emploskills.com" 
                    className="text-primary hover:text-primary-dark transition-colors flex items-center"
                    onClick={handleContactClick}
                  >
                    <span className="mr-2">✉️</span>
                    Email
                  </a>
                  <a 
                    href="tel:+4798815864" 
                    className="text-primary hover:text-primary-dark transition-colors flex items-center"
                    onClick={handleContactClick}
                  >
                    <span className="mr-2">📱</span>
                    +47 988 15 864
                  </a>
                </div>
              </div>
            </div>

            {/* Benjamin */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-xl transition-shadow duration-300">
              <div className="h-[500px] relative overflow-hidden">
                <img 
                  src={benjaminPic}
                  alt="Benjamin Lindmo Ryan"
                  className="absolute w-full h-full object-cover object-[center_15%] transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-8 bg-white relative transition-transform duration-300 group-hover:-translate-y-2 flex flex-col h-[400px]">
                <div className="flex-grow">
                  <h3 className="text-2xl font-bold mb-2 text-gray-900">Benjamin Lindmo Ryan</h3>
                  <p className="text-primary font-medium mb-6 transition-colors duration-300 group-hover:text-primary-dark">
                    Co-Founder and Head of Sales
                  </p>
                  
                  <p className="text-gray-600">
                    My journey with the simulation based learning began during my time as a Secondary Education student, using Hubro's Simulations in my course. I later joined Hubro as an intern, then apprentice, and I have been the Key Account for Secondary Education, from 2020, until now! I bring can bring an unique perspective, having experienced the product firsthand as a student, that will bring valuable insights, and I know the Secondary Education segment very well, having worked with teachers and students across the world.
                  </p>
                </div>
                
                <div className="flex flex-col space-y-2 mt-6">
                  <a 
                    href="mailto:benjamin@emploskills.com" 
                    className="text-primary hover:text-primary-dark transition-colors flex items-center"
                    onClick={handleContactClick}
                  >
                    <span className="mr-2">✉️</span>
                    Email
                  </a>
                  <a 
                    href="tel:+4747685497" 
                    className="text-primary hover:text-primary-dark transition-colors flex items-center"
                    onClick={handleContactClick}
                  >
                    <span className="mr-2">📱</span>
                    +47 47685497
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
} 